angular.module(NgAppName).component('crAds', {
	templateUrl: 'crAds.html',
	transclude: true,
	bindings: {
		url: '@',
		top: '@',
		calloutboxRpc: '@',
		calloutboxAddress: '@',
		calloutboxBuildingPageUrl: '@',
		isLowPriceBuilding: '@',
		prependAds: "@",
		isMobile: '@',
		totalUnits: '@'
	},
	controller: ['$element', '$timeout', '$interval', 'crResourcesService', 'gVariables', function($element, $timeout, $interval, crResourcesService, gVariables) {

		this.$onInit = () => {
			this.keys = [];
			this.ads = {};
			this.gVariables = gVariables;
			this.prepend = this.prependAds === "1" ? true : false;
		};

		this.$postLink = () => {
			let salesHistory = document.querySelector('#sales_history');
			if (salesHistory) {
				// wait for the sales history to be loaded
				let intervalLoadsAds = $interval(() => {
					if (window.buildingAllSalesLoaded) {
						this.loadAds();
						$interval.cancel(intervalLoadsAds);
					}
				}, 500, 20);
			} else {
				this.loadAds();
			}
		};

		this.loadAds = () => {
			this.contentBody1 = document.querySelector('.content_body_1');
			this.contentBody2 = document.querySelector('.content_body_2');
			this.contentBody3 = document.querySelector('.content_body_3');

			let heightBody1 = this.contentBody1.getHeight();
			let heightBody2 = this.contentBody2 ? this.contentBody2.getHeight() : 0;
			let heightBody3 = this.contentBody3 ? this.contentBody3.getHeight() : 0;

			this.adContainer1 = angular.element(document.querySelector('.content_aside_1'));
			this.sideContactContainer = this.adContainer1[0].querySelector('.w_side_contact_container');
			this.adContainer2 = angular.element(document.querySelector('.content_aside_2'));
			this.adContainer3 = angular.element(document.querySelector('.content_aside_3'));

			// ads
			let ads = [
				{
					type: 'medium',
					height: gVariables.mediumAdSize + 20,
					toBeLoaded: false
				},
				{
					type: 'small',
					height: gVariables.smallAdSize + 20,
					toBeLoaded: false
				}
			];
			// containers
			let heightContact = 420;
			let heightOptions = 71;
			let containers = [];
			if (this.top) {
				containers.push({
					height: heightBody1 - heightContact,
					html: this.adContainer1
				});
			} else {
				// if there is no side contact form, then we try to add ads there
				if (!this.sideContactContainer) {
					containers.push({
						height: heightBody1 - heightOptions,
						html: this.adContainer1
					});
				}
				containers.push({
					height: heightBody2,
					html: this.adContainer2
				});
				containers.push({
					height: heightBody3,
					html: this.adContainer3
				});
			}

			let adsRemaining = ads;
			for (let i = 0; i < containers.length; i++) {
				let spaceAvailable = containers[i].height;
				for (let j = 0; j < adsRemaining.length; j++) {
					if (!adsRemaining[j].toBeLoaded && spaceAvailable >= adsRemaining[j].height) {
						adsRemaining[j].toBeLoaded = true;
						spaceAvailable -= adsRemaining[j].height;
					} else {
						break;
					}
				}
				adsRemaining = adsRemaining.filter((x) => {
					return !x.toBeLoaded;
				});
			}


			// get the config to load the ads
			let config = angular.element($element[0].querySelector('.config'));
			let data = JSON.parse(config.text());
			angular.forEach(data.ads, function(ad) {
				ad.limit = 0;
			});
			angular.forEach(data.ads, function(ad) {
				// Medium
				if (ads[0].toBeLoaded && (ad.type == gVariables.adTypeRentalBannerMed || ad.type ==	gVariables.adTypeNewDevBannerMed)) {
					ad.limit = 1;
				}
				// Small
				if (ads[1].toBeLoaded && (ad.type == gVariables.adTypeRentalBannerSmall || ad.type ==	gVariables.adTypeNewDevBannerSmall)) {
					ad.limit = 1;
				}
			});

			crResourcesService.post2(this.url, data).$promise.then((data) => {
				// saved
				if (data && data.data && Object.keys(data.data).length > 0) {
					this.ads = data.data;
					this.keys = Object.keys(this.ads);
					// var keysInt = this.keys.map(k => parseInt(k));
					let min = this.ads[gVariables.adTypeNewDevBannerSmall] ? gVariables.adTypeNewDevBannerSmall : (this.ads[gVariables.adTypeNewDevBannerMed] ? gVariables.adTypeNewDevBannerMed : gVariables.adTypeNewDevBannerLarge);
					if (min) {
						// copy of the last ad object
						if (!!this.ads[min] && !!this.ads[min].length) {
							this.ads[min].push(Object.assign({}, this.ads[min][this.ads[min].length - 1]));
						}

						// add id to prevent dup error in ng-repeat
						for(let i = 0; i < this.keys.length; i++) {
							for(let j = 0; j < this.ads[this.keys[i]].length; j++) {
								this.ads[this.keys[i]][j].id = `${i}${j + 1}`;
							}
						}
					}
					
				}

				this.moveAds();
			}, (error) => {
				// error
			}).finally(() => {
				// ctrl.isLoading = false;
			});
		};

		this.moveAds = () => {
			$timeout(() => {
				let pubLarge = $element[0].querySelectorAll('.w_pub.large');
				let pubMedium = $element[0].querySelectorAll('.w_pub.medium');
				let pubSmall = $element[0].querySelectorAll('.w_pub.small');

				let heightBody1 = this.contentBody1.getHeight();
				let heightBody2 = this.contentBody2 ? this.contentBody2.getHeight() : 0;
				let heightBody3 = this.contentBody3 ? this.contentBody3.getHeight() : 0;

				let stickyPoint = '<div class="sticky-point"></div>';
				let stickyPoint2 = '<div class="sticky-point"></div>';

				let ads = [];
				if (pubLarge && pubLarge.length > 0) {
					ads.push({
						type: 'large',
						height: gVariables.largeAdSize + 20,
						html: pubLarge[0]
					});
				}
				if (pubMedium && pubMedium.length > 0) {
					ads.push({
						type: 'medium',
						height: gVariables.mediumAdSize + 20,
						html: pubMedium[0]
					});
				}
				if (pubSmall && pubSmall.length > 0) {
					ads.push({
						type: 'small',
						height: gVariables.smallAdSize + 20,
						html: pubSmall[0]
					});
				}

				let heightContact = 420;
				let heightOptions = 71;
				let containers = [];
				if (this.top) {
					containers.push({
						id: 1,
						height: heightBody1 - heightContact,
						html: this.adContainer1,
						nbAds: 0
					});
				} else {
					if (!this.sideContactContainer) {
						containers.push({
							id: 1,
							height: heightBody1 - heightOptions,
							html: this.adContainer1,
							nbAds: 0
						});
					}

					containers.push({
						id: 2,
						height: heightBody2,
						html: this.adContainer2,
						nbAds: 0
					});
					containers.push({
						id: 3,
						height: heightBody3,
						html: this.adContainer3,
						nbAds: 0
					});
				}

				let adsRemaining = ads;
				let calloutboxSell = $element[0].querySelector('.calloutbox-sell');
				for (let i = 0; i < containers.length; i++) {
					let spaceAvailable = containers[i].height; 
					if (this.calloutboxRpc && calloutboxSell && containers[i].id === 2) {
						spaceAvailable -= 243; // height of sell callout box 
					}

					var adsToInsert = [];
					var indexStickyPoint = 0;

					for (let j = 0; j < adsRemaining.length; j++) {
						if (spaceAvailable >= adsRemaining[j].height) {
							adsToInsert.push(adsRemaining[j].html);
							adsRemaining[j].inserted = true;
							spaceAvailable -= adsRemaining[j].height;
							indexStickyPoint = j;
							containers[i].nbAds++;
						} else {
							break; 
						}
					}
  
					// insert ads
					if (adsToInsert.length > 0) {
						for (var k = 0; k < adsToInsert.length; k++) {
							if (k === adsToInsert.length - 1) { 
								// inser sticky point
								if (this.prepend) {
									containers[i].html.prepend(stickyPoint); 
								} else {
									containers[i].html.append(stickyPoint); 
								}
								// insert calloutbox 
								if (this.calloutboxRpc && calloutboxSell && containers[i].id === 2) {
									calloutboxSell.append(adsToInsert[k].removeClass('w_pub')); // remove w_pub to make it stick at the calloutbox
									containers[i].html.append(calloutboxSell.removeClass('none'));
								} else {
									if (this.prepend) {
										containers[i].html.prepend(adsToInsert[k]);
									} else {
										containers[i].html.append(adsToInsert[k]);
									}
									
								}
							} else {
								if (this.prepend) {
									containers[i].html.prepend(adsToInsert[k]);
								} else {
									containers[i].html.append(adsToInsert[k]);
								}
							}
						}

						// if multiple sticky point, keep only the last one (currently one is set in php view and one in js...)
						let stickyPoints = containers[i].html[0].querySelectorAll('.sticky-point');
						let nbPoints = stickyPoints.length;
						if (nbPoints > 1) {
							for (let j = (nbPoints - 2); j >=0 ; j--) {
								stickyPoints[j].remove();
							}
						}
					} else {
						// insert calloutbox
						if (this.calloutboxRpc && calloutboxSell && containers[i].id === 2) {
							containers[i].html.append(stickyPoint); 
							containers[i].html.append(calloutboxSell.removeClass('none'));
						}
					}

					adsRemaining = adsRemaining.filter((x) => {
						return !x.inserted;
					});
				}

				// add an ad into the last container
				if (containers[containers.length -1].nbAds === 0) {
					let spaceAvailable = containers[containers.length -1].height;
					let adAtTheEnd = null;
					let smallAds = ads.filter(a => { return a.type === "small" });
					if (smallAds && smallAds.length > 0) {
						adAtTheEnd = {
							id: "000",
							height: smallAds[smallAds.length - 1].height,
							html: pubSmall[1]
						};
					} else {
						let mediumAds = ads.filter(a => { return a.type === "medium" });
						if (mediumAds && mediumAds.length > 0) {
							adAtTheEnd = {
								id: "000",
								height: mediumAds[mediumAds.length - 1].height,
								html: pubMedium[1]
							};
						} else {
							let largeAds = ads.filter(a => { return a.type === "large"});
							if (largeAds && largeAds.length > 0) {
								adAtTheEnd = {
									id: "000",
									height: largeAds[largeAds.length - 1].height,
									html: pubLarge[1]
								};
							}
						}
					}

					if (adAtTheEnd && spaceAvailable > adAtTheEnd.height) {
						// if (!this.prepend) {
							containers[containers.length -1].html.append(stickyPoint2);
						// }
						containers[containers.length -1].html.append(adAtTheEnd.html);
					}
				}
			});
		};

	}]
});
